// Extracted from app/javascript/application.js by ticket #2127 (JS bundle split)
// so both application.js (public) and dashboard.js can call it identically
// without duplicating the logic.
//
// Hotwire Native (iOS/Android) embeds the app in a native WebView. On Android the
// WebView fully supports Service Workers, so the PWA SW would intercept navigations
// (serving offline.html / forcing a controllerchange reload) before Turbo boots —
// the native shell then shows "Turbo Not Present". The SW brings no value inside the
// native app, so we skip registration there and proactively unregister any stale one.
export function bootstrapServiceWorker() {
  const isHotwireNative = /Hotwire Native|Turbo Native/.test(navigator.userAgent)

  if (isHotwireNative) {
    if ("serviceWorker" in navigator) {
      navigator.serviceWorker.getRegistrations()
        .then((registrations) => registrations.forEach((registration) => registration.unregister()))
        .catch(() => {})
    }
    return
  }

  if (!("serviceWorker" in navigator)) return
  // Page qui s'exclut (`<meta name="service-worker" content="off">`) : la page de paiement
  // externe Play, sur un hôte où la première visite installerait le SW et où son
  // `controllerchange` rechargerait la page en pleine saisie.
  if (document.querySelector('meta[name="service-worker"][content="off"]')) return

  navigator.serviceWorker.register("/service-worker.js", { scope: "/" })
    .catch((err) => console.warn("Service worker registration failed:", err))

  let reloading = false
  navigator.serviceWorker.addEventListener("controllerchange", () => {
    if (reloading) return
    reloading = true
    window.location.reload()
  })
}
